import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabbookinginmumbai() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Bookings in Mumbai',
    heading: 'Aaryan Travels: Monthly Corporate Cab Bookings in Mumbai',
    headingDescription: 'Aaryan Travels offers seamless Monthly Corporate Cab Bookings in Mumbai for companies, executives, and employees who require consistent and hassle-free transportation. Whether it’s daily office commute, client transfers, airport pickups from Chhatrapati Shivaji Maharaj International Airport, or intercity travel to Pune and Nashik, our fleet of sedans, SUVs, and premium vehicles is available on structured monthly plans. With professional chauffeurs, GPS-enabled vehicles, punctual reporting, and transparent billing, we ensure reliable mobility across corporate hubs like Andheri, BKC, Thane, Navi Mumbai, and South Mumbai. Aaryan Travels simplifies business travel by providing customized monthly cab booking solutions tailored to your corporate needs in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is Mumbai’s most iconic monument. Originally constructed to welcome British royalty, it now serves as a bustling tourist hub. Visitors enjoy ferry rides to Elephanta Caves and panoramic sea views. Illuminated beautifully at night, it creates a majestic backdrop. Gateway of India is Mumbai’s grand symbol of pride and history."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace due to its crescent line of glowing lights at night, is a 3.6 km-long seaside promenade. Locals gather here for sunset walks, street snacks, and cool sea breeze. It’s a favorite place for contemplation and leisure. Marine Drive is Mumbai’s timeless stretch of peace and beauty."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO-listed railway station built in 1887 in Victorian Gothic style. Its domes, stained-glass windows, and carvings make it look like a royal palace. Despite its heritage structure, it remains one of India’s busiest transport hubs. Lit up at night, it becomes a breathtaking sight. CST is Mumbai’s perfect blend of history and movement."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular sandy retreat, famous for its vibrant atmosphere and street food like pav bhaji and gola ice. Families enjoy camel rides while children play by the shore. Bollywood celebrities often reside nearby, adding glamour. Juhu Beach is Mumbai’s joyful seaside carnival."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet connected by a narrow walkway. During high tide, it appears to float in the sea. Devotees of all faiths visit to seek blessings and enjoy soulful qawwali music. Haji Ali is Mumbai’s serene island of spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th century and feature intricate sculptures of Lord Shiva. The famous Trimurti statue is a highlight. A ferry ride from Gateway of India adds adventure and scenic beauty. Elephanta Caves are Mumbai’s masterpiece carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Devotees, including celebrities and commoners, visit daily to seek blessings. The gold-plated dome and decorated idol radiate divine grace. Siddhivinayak is Mumbai’s powerful center of devotion."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge offering spectacular views of the sea and skyline. Built with advanced engineering, it reduced travel time between the suburbs and South Mumbai. At night, its illuminated structure looks futuristic. The Sea Link is Mumbai’s symbol of modern progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a lively street market known for trendy clothes, jewelry, and souvenirs. Bargain hunters love exploring its colorful stalls. Legendary cafés like Leopold Café and Café Mondegar add vintage charm. Colaba Causeway is Mumbai’s vibrant shopping and culture lane."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering safaris, trekking trails, and boating. The ancient Kanheri Caves inside the park add historical depth. Wildlife such as deer, monkeys, and exotic birds are commonly spotted. SGNP is Mumbai’s refreshing escape into nature."
  }
],



"services": [
  {
    "name": "Monthly Corporate Cab Bookings in Mumbai",
    "description": "Monthly Corporate Cab Bookings in Mumbai provide businesses with reliable and cost-effective transportation solutions for long-term employee and executive travel. This service offers dedicated chauffeur-driven vehicles for an entire month, ensuring consistent quality, punctuality, and professional drivers. With fixed monthly pricing and comprehensive maintenance, companies can streamline their daily office commutes, business meetings, and client visits without worrying about logistics."
  },
  {
    "name": "Mumbai Monthly Cab Hire",
    "description": "Mumbai Monthly Cab Hire delivers flexible and convenient vehicle rental options for corporate clients needing monthly transportation. The service includes a variety of well-maintained cars driven by trained chauffeurs, designed to meet the diverse requirements of businesses and ensure timely, comfortable travel throughout the city."
  },
  {
    "name": "Corporate Taxi Mumbai Monthly",
    "description": "Corporate Taxi Mumbai Monthly provides dependable taxi services on a recurring monthly basis for corporate clients. With professional drivers, prompt support, and scalable fleet options, this service helps companies optimize their transportation needs efficiently while maintaining high standards of comfort and safety."
  },
  {
    "name": "Office Cab Services Mumbai",
    "description": "Office Cab Services Mumbai specialize in organizing daily employee transport with fixed routes and schedules. This service emphasizes safety, punctuality, and convenience to help companies ensure their workforce arrives at the workplace on time and in comfort."
  },
  {
    "name": "Business Travel Cab Mumbai",
    "description": "Business Travel Cab Mumbai caters to executives and business professionals requiring reliable transportation for meetings, client visits, and corporate events. Offering timely pickups, professional chauffeurs, and premium vehicles, this service enhances productivity by reducing travel-related stress."
  },
  {
    "name": "Chauffeur Driven Corporate Cab Mumbai",
    "description": "Chauffeur Driven Corporate Cab Mumbai provides executive-class transportation with experienced chauffeurs trained in corporate etiquette. Ideal for senior management and VIP clients, this service guarantees discretion, professionalism, and comfort throughout every journey."
  },
  {
    "name": "Affordable Monthly Corporate Cab Mumbai",
    "description": "Affordable Monthly Corporate Cab Mumbai combines quality service with competitive pricing to offer cost-effective monthly cab plans. Perfect for startups and SMEs, this service ensures reliable transportation solutions without compromising on vehicle standards or driver professionalism."
  },
  {
    "name": "Staff Transport Cab Mumbai",
    "description": "Staff Transport Cab Mumbai offers dependable daily transport services designed specifically for employees. With route optimization and fleet management, the service helps companies maintain smooth staff commutes while prioritizing safety and punctuality."
  },
  {
    "name": "Executive Cab Services Mumbai",
    "description": "Executive Cab Services Mumbai deliver premium taxi services tailored for business leaders and corporate clients. Featuring luxury vehicles and discreet chauffeurs, this service provides a high-end travel experience that reflects professionalism and class."
  },
  {
    "name": "Corporate Car Lease Mumbai",
    "description": "Corporate Car Lease Mumbai offers long-term vehicle leasing options for businesses seeking consistent and hassle-free mobility solutions. With a focus on maintenance, driver support, and flexible lease plans, companies can enjoy seamless transport for their teams and executives."
  },
  {
    "name": "Long Term Corporate Cab Mumbai",
    "description": "Long Term Corporate Cab Mumbai provides extended rental plans including monthly and quarterly options, catering to companies that require ongoing corporate transportation. The service is designed to offer flexibility, reliable vehicles, and professional drivers to support all business travel needs."
  },
  {
    "name": "Mumbai Business Taxi",
    "description": "Mumbai Business Taxi specializes in corporate taxi services for business-related travel. With professional drivers and timely service, this option is ideal for executives, clients, and staff needing prompt and comfortable transportation across the city."
  },
  {
    "name": "Company Cab Booking Mumbai",
    "description": "Company Cab Booking Mumbai streamlines corporate transport management by allowing businesses to schedule and manage cab services easily. This service supports both short-term and long-term bookings with transparent pricing and dedicated customer support."
  },
  {
    "name": "Monthly Vehicle Hire Mumbai",
    "description": "Monthly Vehicle Hire Mumbai offers flexible monthly rental packages suitable for corporate clients needing vehicles with or without drivers. The service ensures well-maintained cars, timely service, and customizable plans to fit company transport requirements."
  },
  {
    "name": "Monthly Corporate Transport Mumbai",
    "description": "Monthly Corporate Transport Mumbai provides comprehensive transportation solutions for companies with recurring travel demands. This service features dedicated vehicles, professional chauffeurs, and optimized routes to ensure seamless and efficient staff and executive travel."
  }
],
"tableData": [
  ["Monthly Corporate Cab Bookings in Mumbai", "Mumbai Monthly Cab Hire"],
  ["Corporate Taxi Mumbai Monthly", "Office Cab Services Mumbai"],
  ["Business Travel Cab Mumbai", "Chauffeur Driven Corporate Cab Mumbai"],
  ["Affordable Monthly Corporate Cab Mumbai", "Staff Transport Cab Mumbai"],
  ["Executive Cab Services Mumbai", "Corporate Car Lease Mumbai"],
  ["Long Term Corporate Cab Mumbai", "Mumbai Business Taxi"],
  ["Company Cab Booking Mumbai", "Monthly Vehicle Hire Mumbai"],
  ["Monthly Corporate Transport Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Bookings in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers reliable monthly corporate cab bookings in Mumbai, designed to streamline your business travel needs."
  },
  {
    "WhyChooseheading": "Punctual and Professional Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs to keep your corporate schedule running smoothly."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for safety and comfort throughout your monthly rental."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers know Mumbai’s roads well, ensuring efficient and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly pricing inclusive of fuel, tolls, and driver allowances for worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible and Customizable Plans",
    "WhyChoosedescription": "Choose plans tailored to your corporate travel requirements and vehicle preferences."
  },
  {
    "WhyChooseheading": "Dedicated Fleet for Corporate Clients",
    "WhyChoosedescription": "Benefit from priority service and dedicated vehicles assigned exclusively for your organization."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab bookings in Mumbai?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly corporate cab booking plans in Mumbai tailored to meet your business travel needs.',
  },
  {
    question: 'How can I book monthly corporate cab bookings in Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team in Mumbai.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate cab bookings in Mumbai?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and premium cars suited for corporate travel.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab bookings in Mumbai?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly bookings in Mumbai?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Mumbai and nearby business areas.',
  },
  {
    question: 'Is the monthly corporate cab booking service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab booking services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for monthly corporate cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for monthly corporate cab bookings in Mumbai?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the monthly corporate cab booking period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your booking period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Desai',
    feedback: 'Aaryan Travels made our monthly corporate cab bookings in Mumbai smooth and hassle-free with excellent drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Reliable monthly corporate cab booking service by Aaryan Travels in Mumbai. Highly recommend for business travel!',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const monthlyCorporateCabMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Bookings in Mumbai",
  "description": "Aaryan Travels provides reliable monthly corporate cab bookings in Mumbai with professional chauffeurs. Ideal for employee transport, business executives, and long-term corporate travel needs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Monthly Corporate Cab Bookings",
  "keywords": "Monthly Corporate Cab Bookings in Mumbai, Mumbai Monthly Cab Hire, Corporate Taxi Mumbai Monthly, Office Cab Services Mumbai, Business Travel Cab Mumbai, Chauffeur Driven Corporate Cab Mumbai, Affordable Monthly Corporate Cab Mumbai, Staff Transport Cab Mumbai, Executive Cab Services Mumbai, Corporate Car Lease Mumbai, Long Term Corporate Cab Mumbai, Mumbai Business Taxi, Company Cab Booking Mumbai, Monthly Vehicle Hire Mumbai, Monthly Corporate Transport Mumbai"
};






  return (
    <div>

<Helmet>
  <title>Monthly Corporate Cab Bookings in Mumbai | Long-Term Office Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cabs in Mumbai with Aaryan Travels. Reliable chauffeur-driven vehicles for office staff, executives, and business travel on long-term rental plans."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Bookings in Mumbai, Mumbai Monthly Cab Hire, Corporate Taxi Mumbai Monthly, Office Cab Services Mumbai, Business Travel Cab Mumbai, Chauffeur Driven Corporate Cab Mumbai, Affordable Monthly Corporate Cab Mumbai, Staff Transport Cab Mumbai, Executive Cab Services Mumbai, Corporate Car Lease Mumbai, Long Term Corporate Cab Mumbai, Mumbai Business Taxi, Company Cab Booking Mumbai, Monthly Vehicle Hire Mumbai, Monthly Corporate Transport Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabMumbaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabbookinginmumbai;